import { connect } from 'react-redux'
import { compose } from 'redux'
import toJS from '../../../hoc/toJS'
import ListItemMovieContainer from "./ListItemMovieContainer";
import { MOVIE } from '../../../constants/itemTypes';
import getData from '../../../functions/getData';
import { PROGRAM_CLI_MOVIES_ITEMS } from '../../../constants/state';

const mapStateToProps = (state, ownProps) => ({
    itemData:  getData(state, [PROGRAM_CLI_MOVIES_ITEMS, ownProps.itemId])
})

const ListItemDataMovieContainer = ({
    itemId,
    itemData,
    additionalClass =  false,
    isSelected = false,
    pathnameEdit = false,
    onDeleteItem = false
}) => <ListItemMovieContainer
    itemType={MOVIE}
    itemData={itemData}
    additionalClass={additionalClass}
    isSelected={isSelected}
    pathnameEdit={pathnameEdit}
    onDelete={() => onDeleteItem(itemId)}

/>

export default compose(
    connect(mapStateToProps, null),
    toJS()
)(ListItemDataMovieContainer)